module.exports = __webpack_public_path__ + "img/icon_next_double.f25fbe89.svg";